<template>
  <generic-modal :title="modal_title" ref="generic_modal">
    <div class="columns is-multiline">
      <!-- Name -->
      <div class="column is-12">
        <div class="field">
          <label class="label">{{ $t("name") }} *</label>
          <div class="control">
            <input
              v-model="form.name"
              class="input"
              :class="{ 'is-danger': error.name }"
              type="text"
              :placeholder="$t('enter department name')"
            />
          </div>
          <p v-if="error.name" class="help is-danger">{{ error.name }}</p>
        </div>
      </div>

      <!-- Description -->
      <div class="column is-12">
        <div class="field">
          <label class="label">{{ $t("description") }}</label>
          <div class="control">
            <textarea
              v-model="form.description"
              class="textarea"
              :placeholder="$t('enter department description')"
              rows="3"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- Manager -->
      <!-- <div class="column is-6">
        <div class="field">
          <label class="label">{{ $t("manager") }}</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="form.manager_uuid">
                <option value="">{{ $t("select manager") }}</option>
                <option
                  v-for="collaborator in collaborators"
                  :key="collaborator.uuid"
                  :value="collaborator.uuid"
                >
                  {{ collaborator.first_name }} {{ collaborator.last_name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Budget -->
      <div class="column is-6" v-if="form.settings">
        <div class="field">
          <label class="label">{{ $t("budget") }}</label>
          <div class="control">
            <input
              v-model="form.settings.budget"
              class="input"
              type="number"
              step="0.01"
              min="0"
              :placeholder="$t('enter budget amount')"
            />
          </div>
        </div>
      </div>

      <!-- Status -->
      <div class="column is-6">
        <div class="field">
          <label class="label">{{ $t("status") }}</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="form.status">
                <option value="active">{{ $t("active") }}</option>
                <option value="inactive">{{ $t("inactive") }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Messages -->
    <div class="notification is-danger" v-if="error_message">
      {{ error_message }}
    </div>

    <!-- Footer with buttons using v-slot pattern -->
    <template v-slot:footer>
      <button
        class="button is-success"
        @click="save_department"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-check" :class="{ 'fa-spin': loading }"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button" @click="close_modal">
        <span class="icon">
          <i class="fa fa-times"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import {
  generate_error_message_text,
  del,
  post,
  put,
  get,
  success_message,
  error_message,
} from "@/utils";

export default {
  name: "DepartmentModal",
  components: {
    GenericModal,
  },
  data() {
    return {
      loading: false,
      editing_uuid: null,
      collaborators: [],
      error_message: "",
      form: {
        name: "",
        description: "",
        manager_uuid: "",
        settings: { budget: "" },
        status: "active",
      },
      error: {},
    };
  },
  computed: {
    modal_title() {
      return this.editing_uuid
        ? this.$t("edit department")
        : this.$t("new department");
    },
    is_form_invalid() {
      return !this.form.name;
    },
  },
  mounted() {
    // this.load_collaborators();
  },
  methods: {
    show_modal(uuid = null) {
      this.editing_uuid = uuid;
      this.set_initial_state();

      if (uuid) {
        this.load_department(uuid);
      }

      this.$refs.generic_modal.show_modal();
    },
    close_modal() {
      this.$refs.generic_modal.close_modal();
      this.set_initial_state();
    },
    set_initial_state() {
      this.form = {
        name: "",
        description: "",
        manager_uuid: "",
        settings: { budget: "" },
        status: "active",
      };
      this.error = {};
      this.error_message = "";
    },
    // load_collaborators() {
    //   get("/personal/collaborator/catalog")
    //     .then((collaborators) => {
    //       this.collaborators = collaborators;
    //     })
    //     .catch((error) => {
    //       console.error("Error loading collaborators:", error);
    //       this.error_message = generate_error_message_text(error);
    //     });
    // },
    load_department(uuid) {
      get("/staff/department", { uuid: uuid })
        .then((department) => {
          this.form = department;
        })
        .catch((error) => {
          console.error("Error loading department:", error);
          this.error_message = generate_error_message_text(error);
        });
    },
    save_department() {
      if (this.is_form_invalid) {
        error_message(this.$t("please fill required fields"));
        return;
      }

      this.loading = true;
      this.error = {};
      this.error_message = "";

      let payload = { ...this.form };

      if (this.editing_uuid) {
        payload.uuid = this.editing_uuid;
        post("/staff/department", payload)
          .then(() => {
            let message = this.$t("department updated successfully");
            success_message(message);
            this.$emit("success");
            this.close_modal();
          })
          .catch((error) => {
            console.error("Error saving department:", error);
            this.error_message = generate_error_message_text(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        put("/staff/department", payload)
          .then(() => {
            let message = this.$t("department created successfully");
            success_message(message);
            this.$emit("success");
            this.close_modal();
          })
          .catch((error) => {
            console.error("Error saving department:", error);
            this.error_message = generate_error_message_text(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
